import { Delete, Edit, MoreVert } from '@mui/icons-material'
import { Divider, IconButton, Menu } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ListItemButton } from 'components/List'
import { useMenu } from 'hooks/useMenu'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { useDeleteWorkspace } from '../../hooks/useDeleteWorkspace'
import { ActionsCellProps } from './types'

export const ActionsCell = ({ id, name }: ActionsCellProps): JSX.Element => {
  const ability = useAbility()
  const { t } = useTranslation('features/workspace')
  const { t: tC } = useTranslation('common')
  const navigate = useNavigate()
  const { anchor, close, isOpen, open } = useMenu()
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const { deleteWorkspace, loading } = useDeleteWorkspace({ name })

  const handleDelete = (): void => {
    close()
    setIsDialogOpen(true)
  }

  const EditItem = (): JSX.Element => (
    <ListItemButton
      data-cy='actions-edit'
      icon={<Edit />}
      onClick={() => navigate(generatePath(ROUTES.WORKSPACE.EDIT, { id }))}
      text={tC('form.action.edit')}
    />
  )

  const DeleteItem = (): JSX.Element => (
    <ListItemButton
      data-cy='actions-delete'
      icon={<Delete />}
      onClick={handleDelete}
      text={tC('form.action.delete')}
    />
  )

  return (
    <>
      <IconButton onClick={open}>
        <MoreVert />
      </IconButton>

      <Menu
        anchorEl={anchor}
        onClose={close}
        open={isOpen}
      >
        <EditItem />

        {ability.can('delete', 'Workspace') && [
          <Divider
            key='divider'
            sx={{ my: 1 }}
          />,
          <DeleteItem key='delete' />,
        ]}
      </Menu>

      <DeleteDialog
        dialog={{ isOpen: isDialogOpen, setOpen: setIsDialogOpen }}
        i18nResource={t}
        loading={loading}
        onDelete={() => void deleteWorkspace(id)}
      />
    </>
  )
}
